const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:3001/api";

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  school: string;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
  user?: {
    id: string;
    email: string;
    displayName: string;
    role: string;
    school: string;
  };
  token?: string;
}

export const authService = {
  async register(data: RegisterData): Promise<RegisterResponse> {
    try {
      console.log(
        "Attempting to register at:",
        `${API_BASE_URL}/auth/register`
      );

      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
          display_name: `${data.firstName} ${data.lastName}`,
          first_name: data.firstName,
          last_name: data.lastName,
          school: data.school,
          role: "student",
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Registration failed");
      }

      // Store token if provided
      if (result.token) {
        localStorage.setItem("authToken", result.token);
      }

      return result;
    } catch (error) {
      console.error("Registration error details:", error);
      if (error instanceof Error) {
        if (error.message === "Failed to fetch") {
          throw new Error(
            "Unable to connect to server. Please ensure the backend is running."
          );
        }
        throw error;
      }
      throw new Error("Network error. Please check your connection.");
    }
  },
};
